<template id="Dashboard">
    <v-app class="dashboard-page">
        <v-container fluid class="dashboard-content">
            <header class="dashboard-heading">
                <div>
                    <p class="dashboard-eyebrow">Your workspace</p>
                    <h1>Dashboard</h1>
                    <p class="dashboard-intro">Choose a module to get started.</p>
                </div>
                <span class="module-count">{{ getNavbarItems.length }} modules available</span>
            </header>
            <v-row class="module-grid">
                <v-col lg="3" md="4" sm="6" cols="12" v-for="item in getNavbarItems" :key="item.prefix">
                    <v-card class="module-card" elevation="0" :to="'/module/' + item.prefix" :aria-label="'Open ' + item.name">
                        <div class="module-card-top">
                            <span class="module-icon"><v-icon :icon="item.icon || 'mdi-view-grid-outline'" size="28" /></span>
                            <v-icon icon="mdi-arrow-top-right" size="20" class="module-arrow" />
                        </div>
                        <h2 class="module-title">{{ item.name }}</h2>
                        <div class="module-card-footer">
                            <span>Open module</span>
                            <v-icon icon="mdi-arrow-right" size="18" />
                        </div>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>

import breadCrumbs from '@/components/utils/breadCrumbs.vue';
import {useStore} from 'vuex';

export default {
        components: {
            breadCrumbs,
        },
        name: 'Dashboard',
        data: () => ({
            loading:false,
            form_loading: false,
            errorMessages:'',
            search: "",
            options: {
                chart: {
                id: 'vuechart-example'
                },
                xaxis: {
                categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998]
                }
            },
            series: [{
                name: 'series-1',
                data: [30, 40, 45, 50, 49, 60, 70, 91]
            }]
        }),

        watch: {
        },
        created(){
            // this.form_loading = true;
        //     this.$store.dispatch('getDashboardList').then(data => {
        //         this.form_loading = false;
        //    });
        },
        computed:{
            getSchema() {
                return this.$store.getters.getMenuList;
            },
            getNavbarItems(){
                return this.$store.getters.getNavbarItems
            }
        },
        methods: {
            clear(){

            },
            goTo(val) {
                    this.$router.push({ path: val }).catch(err => {});
            },
            getDataFromApi(){
                this.loading = true;
                this.$store.dispatch('getMenuList')
                .then(data => {
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    toast.error(error.response.data.message); 
                })
                .then(always => {
                    this.loading = false;
                })
            },

        },

        mounted() {
            // this.getDataFromApi();
          }  
    }
</script>

<style scoped>
.dashboard-content { max-width: 1680px; padding: 32px; color: #243c3a; }
.dashboard-heading { display: flex; align-items: flex-end; justify-content: space-between; gap: 20px; margin-bottom: 28px; }
.dashboard-eyebrow { margin-bottom: 8px; color: #117873; font-size: 12px; font-weight: 700; letter-spacing: 1.2px; text-transform: uppercase; }
.dashboard-heading h1 { color: #173f39; font-size: 30px; line-height: 1.2; font-weight: 700; letter-spacing: -.6px; }
.dashboard-intro { margin-top: 10px; color: #6b807b; font-size: 14px; }
.module-count { padding: 8px 12px; border: 1px solid #d5e6e1; background: #edf5f2; color: #42695f; font-size: 12px; white-space: nowrap; }
.module-grid > .v-col { display: flex; }
.module-card { display: flex; flex-direction: column; width: 100%; min-height: 202px; padding: 24px; border: 1px solid #dce8e3; border-top: 3px solid #117873; background: white; color: #243c3a; text-decoration: none; transition: border-color .18s ease, box-shadow .18s ease, transform .18s ease; }
.module-card-top { display: flex; align-items: center; justify-content: space-between; margin-bottom: 22px; }
.module-icon { display: inline-flex; align-items: center; justify-content: center; width: 52px; height: 52px; background: #eaf5f1; color: #ea580c; }
.module-card:hover .module-icon { color: #c2410c; }
.module-arrow { color: #90a7a0; transition: color .18s ease; }
.module-title { margin-bottom: 22px; font-size: 17px; line-height: 1.45; font-weight: 700; overflow-wrap: anywhere; }
.module-card-footer { display: flex; align-items: center; justify-content: space-between; margin-top: auto; padding-top: 14px; border-top: 1px solid #edf2ef; color: #52766b; font-size: 12px; font-weight: 600; }
.module-card:hover { border-color: #76b5a8; box-shadow: 0 8px 24px #164d3e12 !important; transform: translateY(-3px); }
.module-card:hover .module-arrow, .module-card:hover .module-card-footer { color: #117873; }
.module-card:focus-visible { outline: 3px solid #117873; outline-offset: 4px; }
@media (max-width: 600px) {
  .dashboard-content { padding: 20px 16px; }
  .dashboard-heading { align-items: flex-start; flex-direction: column; gap: 14px; }
  .module-card { min-height: 180px; padding: 20px; }
}
@media (prefers-reduced-motion: reduce) {
  .module-card, .module-arrow { transition: none; }
  .module-card:hover { transform: none; }
}
</style>
